// Produits "coup de cœur" — désormais pilotés par le flag `is_featured` en base
// (modifiable depuis la fiche produit en admin), et non plus par une liste codée en dur.
// Ordre d'affichage : coups de cœur en tête, les plus récemment épinglés d'abord.

export function isFeatured(product) {
  return !!(product && product.is_featured);
}

function featuredRank(p) {
  // featured_at récent = prioritaire ; absence de date = plus ancien
  return p?.is_featured ? (p.featured_at || "") : null;
}

/**
 * Trie une liste de produits en plaçant les coups de cœur en premier
 * (par date d'épinglage décroissante), puis garde l'ordre source pour le reste.
 */
export function sortFeaturedFirst(products) {
  if (!Array.isArray(products)) return products;
  const featured = products.filter(p => p?.is_featured);
  featured.sort((a, b) => (b.featured_at || "").localeCompare(a.featured_at || ""));
  const rest = products.filter(p => !p?.is_featured);
  return [...featured, ...rest];
}

/**
 * Pour la HomePage : renvoie les produits coup de cœur (dans l'ordre d'épinglage),
 * en incluant ceux en rupture (un badge sera affiché côté UI).
 */
export function pickFeaturedForHome(allProducts) {
  if (!Array.isArray(allProducts)) return [];
  return sortFeaturedFirst(allProducts.filter(p => p?.is_featured));
}
